module.exports = __webpack_public_path__ + "cae06591d0546c723430268e69483e0b.png";